module.exports = __webpack_public_path__ + "static/img/int5.ad70797e.jpg";